export const data = [
	{
		"headline":"Investigation: How TikTok's algorithm works",
		"link":["TikTok's Algorithm","https://www.wsj.com/video/series/inside-tiktoks-highly-secretive-algorithm/investigation-how-tiktok-algorithm-figures-out-your-deepest-desires/6C0C2040-FF25-4827-8528-2BD6612E3796"],
		"date":"24/07/2021",
		"tags":"Tech, Algorithm"
	},
	{
		"headline":"How to Achieve Your Most Ambitious Goals",
		"link":["Stephen Duneier","https://www.youtube.com/watch?v=TQMbvJNRpLE&ab_channel=TEDxTalks"],
		"date":"28/05/2021",
		"tags":"Life, Self"
	},
	{
		"headline":"How to Figure Out What You Really Want",
		"link":["Ashley Stahl","https://www.youtube.com/watch?v=bRtBHF-WPpM&ab_channel=TEDxTalks"],
		"date":"22/05/2021",
		"tags":"Life, Self"
	},
	{
		"headline":"This guy hosted a party in google docs",
		"link":["Party!!","https://onezero.medium.com/party-in-a-shared-google-doc-d576c565706e"],
		"date":"26/04/2021",
		"tags":"Fun, Creative"
	},
	{
		"headline":"This is a list of things you’re allowed to do that you thought you couldn’t, or didn’t even know you could.",
		"link":["Things To Do","https://milan.cvitkovic.net/writing/things_youre_allowed_to_do/"],
		"date":"24/04/2021",
		"tags":"Awareness, Life"
	},
	{
		"headline":"This guy investigated why McDonald's Ice-Cream machines are always broken. Exposing how corporates bully franchise owners.",
		"link":["Johnny Harris","https://www.youtube.com/watch?v=SrDEtSlqJC4"],
		"date":"22/04/2021",
		"tags":"Awareness, Movement"
	},
	{
		"headline":"Delta-4 theory for Startup Ideas and Efficiency.",
		"link":["Kunal Shah","https://www.youtube.com/watch?v=76eNxRSyOyE"],
		"date":"20/04/2021",
		"tags":"Startups, Innovation"
	},
	{
		"headline":"Neuralink is developing brain-machine interface (BMI) with the goal of enabling people with paralysis to directly use their neural activity to operate computers and mobile devices with speed and ease. Watch a monkey playing PingPong using the same technology.",
		"link":["Neuralink","https://neuralink.com/blog/"],
		"date":"09/04/2021",
		"tags":"Innovation"
	},
	{
		"headline":"Curious if your email or phone info is in a data breach ? Check here.",
		"link":["Have I Been Pawned","https://haveibeenpwned.com/"],
		"date":"07/04/2021",
		"tags":"Security"
	},
	{
		"headline":"How companies reduces lifesize of their products, so that you keep buying more and more. Brilliantly explained on Veritasium channel.",
		"link":["Veritasium","https://www.youtube.com/watch?v=j5v8D-alAKE"],
		"date":"05/04/2021",
		"tags":"Awareness"
	},
	{
		"headline":"A huge list of alternatives to Google products",
		"link":["DeGoogle","https://github.com/tycrek/degoogle"],
		"date":"03/04/2021",
		"tags":"Movement"
	},
	{
		"headline":"Everything is unbearably slow: Software Dis-enchantment",
		"link":["Disenchantment","https://tonsky.me/blog/disenchantment/"],
		"date":"02/04/2021",
		"tags":"Innovation"
	},
	{
		"headline":"A Twitter crawler for app ideas that people wish existed",
		"link":["I Wish There Was","https://iwishtherewas.app/"],
		"date":"01/04/2021",
		"tags":"Ideas"
	},
	{
		"headline":"Right to repair movement: Check Louis Rossmann's channel to know more about his contribution towards this movement",
		"link":["Louis Rossmann","https://www.youtube.com/watch?v=dWIF3ZRpf0I"],
		"date":"01/04/2021",
		"tags":"Movement"
	},
	{
		"headline":"Check IFixit for free repair manuals and thier contribution for Right To Repair movement.",
		"link":["IFixit","https://www.ifixit.com/"],
		"date":"01/04/2021",
		"tags":"Movement"
	}
];